import ZlbConfirm from '@/components/ZlbConfirm';
import {
  reqAbnormalUserList,
  reqHandleExceptions,
  reqExceptionsStatusType,
} from '../services';

/**
 * 请求错误信息统一处理
 * @param res
 */
const responseErrorHandle = (res) => {
  const { success, message } = res;
  if (!success) {
    ZlbConfirm({
      title: message,
      showOkBtn: false,
      cancelText: '知道了',
    });
  }
  return success;
};

export default {
  namespace: 'abnormalUser',
  state: {
    abnormalUserlist: [],
  },
  effects: {
    // 列表
    * fetchAbnormalUserList ({ payload }, { call, put }) {
      const res = yield call(reqAbnormalUserList, payload);
      responseErrorHandle(res);
      const { result = {} } = res;
      yield put({
        type: 'update',
        payload: {
          abnormalUserlist: result.data || [],
        },
      });
      return res;
    },
    * handleExceptions ({ payload }, { call, put }) {
      const res = yield call(reqHandleExceptions, payload);
      responseErrorHandle(res);
      return res;
    },
    * fetchExceptionsStatusType ({ payload }, { call, put }) {
      const res = yield call(reqExceptionsStatusType, payload);
      responseErrorHandle(res);
      return res;
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
